

import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/modals-obligation-explanation';

const mainimage = '/Images/obligation1.webp';

const sections = [
  { label: "Exercises", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "obligation" },
];

const ModalsObligation = () => (
  <GrammarPageLayout
    level="B2"
    title="Modals Obligation"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Modals of Obligation Exercises"
    seoDescription="Express obligation and advice precisely with must, have to, should, ought to. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default ModalsObligation;

